import { pageBackgroundStyle } from '@ui/components/Background/PageBackground';
import { CompetitionPage as CompetitionContent } from '@ui/features/Competition/CompetitionPage';
import { TopNavBar } from '@ui/layouts/components/TopNavBar';
import { makeStaticProps } from '@ui/lib/i18n/build-time';
import { ns } from '@ui/lib/i18n/i18n.config';
import { NextPage } from 'next';
import { Flex } from 'styled-system/jsx';

const Page: NextPage = () => {
  return (
    <Flex direction="column" minHeight="100vh" style={pageBackgroundStyle}>
      <TopNavBar />
      <CompetitionContent />
    </Flex>
  );
};

export default Page;

export const getStaticProps = makeStaticProps(ns);
